import React from 'react';
import { mentalCapacityOptions } from './utils';
import { MentalCapacityData } from '../../StepThreeTypes';

interface MentalCapacitySafeGuardingProps {
  mentalCapacity: MentalCapacityData;
  setMentalCapacity: (data: MentalCapacityData) => void;
}

const MentalCapacitySafeGuarding: React.FC<MentalCapacitySafeGuardingProps> = ({
  mentalCapacity,
  setMentalCapacity,
}) => {
  return (
    <div>
      <div className="govuk-form-group mt-10 govuk-bp:mt-14">
        <fieldset className="govuk-fieldset">
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Mental capacity and safeguarding
            </h1>
          </legend>
          <div id="mc-and-safeguarding-hint" className="govuk-hint">
            Does the person have mental capacity now, when documenting their
            Advance Care Plan?
          </div>
          <div
            className="govuk-radios care-status__radios"
            data-module="govuk-radios"
          >
            {mentalCapacityOptions.map(option => {
              return (
                <div className="govuk-radios__item" key={option.value}>
                  <input
                    className="govuk-radios__input"
                    id="mental-capactity-status"
                    name="mentalCapacityStatus"
                    type="radio"
                    value={option.value}
                    checked={
                      mentalCapacity.mentalCapacityStatus === option.value
                    }
                    onChange={e =>
                      setMentalCapacity({
                        ...mentalCapacity,
                        mentalCapacityStatus: e.target.value,
                      })
                    }
                  />
                  <label
                    className="govuk-label govuk-radios__label"
                    htmlFor={option.value}
                  >
                    {option.label}
                  </label>
                </div>
              );
            })}
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default MentalCapacitySafeGuarding;
